import React, { useEffect } from 'react';
import { ParagraphText, Box } from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { EASYPLAN_ASSET_KEYS } from '../../../types/easy-plan-asset.types';
import useEasyPlanStore from '../../../store/easy-plan-store';
import { EasyPlanContainerComponent } from '../easyPlan-container.component';

export function WelcomeComponent(props: any) {
  const { errorHandling } = props;
  const easyPlanResponse = useEasyPlanStore(
    (state: any) => state.easyPlanHomeInfo,
  );
  useEffect(() => {
    errorHandling(true);
  }, [errorHandling]);

  return (
    <EasyPlanContainerComponent
      image={
        useStaticAsset(EASYPLAN_ASSET_KEYS.TOP_IMAGE_WELCOME_ICON) as string
      }
      title={easyPlanResponse?.easyPlanHome?.welcome?.title}
      description={easyPlanResponse?.easyPlanHome?.welcome?.description}
      dataTestId="welcomeComponent"
    >
      <Box css={{ width: '327px' }}>
        <ParagraphText
          css={{
            marginTop: '$half',
            marginBottom: '$oneAndHalf',
            fontSize: '$bodyOne',
            lineHeight: '$headingFour',
            textAlign: 'center',
          }}
        >
          {easyPlanResponse?.easyPlanHome?.welcome?.footerDescription}
        </ParagraphText>
      </Box>
    </EasyPlanContainerComponent>
  );
}
